if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* ==========================================================
   SMART PICK & PAY CUSTOM PRODUCT PAGE AJAX ADD TO CART
   Keeps the shopper on the PDP, lets the cart-drive animation
   finish, shows Added, then opens the existing cart drawer.
   Homepage quick-add behavior is not changed here.
========================================================== */
(function () {
  if (window.__sppPdpAjaxCartDrawerV1) return;
  window.__sppPdpAjaxCartDrawerV1 = true;

  var customFormSelector = 'form[data-type="add-to-cart-form"]';
  var customButtonSelector = '.spap-btn-cart';

  function isCustomProductForm(form) {
    return !!(form && form.matches && form.matches(customFormSelector) && form.querySelector(customButtonSelector));
  }

  function getSubmitButton(form, event) {
    if (event && event.submitter && event.submitter.matches && event.submitter.matches(customButtonSelector)) {
      return event.submitter;
    }
    return form ? form.querySelector(customButtonSelector) : null;
  }

  function productMotionButtons() {
    return document.querySelectorAll('.spap-btn-cart, .spap-sticky-bar__btn');
  }

  function releaseForm(form, button) {
    if (form) form.removeAttribute('data-spp-ajax-busy');
    if (button && !button.disabled) button.removeAttribute('aria-disabled');
  }

  function showFallbackError(message) {
    var actions = document.querySelector('.spap-actions');
    if (!actions) return;

    var box = document.querySelector('[data-spp-pdp-atc-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-spp-pdp-atc-error', '');
      box.setAttribute('role', 'alert');
      box.style.marginTop = '8px';
      box.style.padding = '10px 12px';
      box.style.border = '1px solid #ffd1bf';
      box.style.borderRadius = '10px';
      box.style.background = '#fff5f0';
      box.style.color = '#8a2d08';
      box.style.fontSize = '12px';
      box.style.fontWeight = '700';
      actions.insertAdjacentElement('afterend', box);
    }

    box.textContent = message || 'We could not add this item to your cart. Please try again.';
    box.hidden = false;
  }

  function clearFallbackError() {
    var box = document.querySelector('[data-spp-pdp-atc-error]');
    if (box) box.hidden = true;
  }

  function markMotionError() {
    productMotionButtons().forEach(function (button) {
      button.classList.remove('spp-atc-motion--running', 'spp-atc-motion--added');
      button.classList.add('spp-atc-motion--error');
      window.setTimeout(function () {
        button.classList.remove('spp-atc-motion--error');
      }, 360);
    });
  }

  function publishCartError(formData, response) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'spp-custom-product-form',
          productVariantId: formData.get('id'),
          errors: response && (response.errors || response.description),
          message: response && response.message
        });
        return;
      }
    } catch (error) {
      console.warn('SPP cart error event failed', error);
    }
    markMotionError();
  }

  function signalCartSuccess(formData, response) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'spp-custom-product-form',
          productVariantId: formData.get('id'),
          cartData: response
        });
      }
    } catch (error) {
      console.warn('SPP cart update event failed', error);
    }

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        source: 'spp-custom-product-form',
        productVariantId: formData.get('id'),
        cartData: response
      }
    }));
  }

  function renderDrawerWithoutOpening(drawer, response) {
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    var originalOpen = drawer.open;
    drawer.open = function () {};

    try {
      drawer.renderContents(response);
      drawer.classList.remove('is-empty');
    } catch (error) {
      console.error('SPP cart drawer render error', error);
    }

    window.setTimeout(function () {
      drawer.open = originalOpen;
    }, 80);
  }

  function scheduleDrawerOpen(drawer, form, button, startedAt) {
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animationMinimum = reducedMotion ? 80 : 1580;
    var elapsed = Math.max(0, Date.now() - startedAt);
    var delay = Math.max(650, animationMinimum - elapsed + 650);

    window.setTimeout(function () {
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(button || undefined);
      }
      releaseForm(form, button);
    }, delay);
  }

  function makeFetchConfig(formData) {
    var config;

    if (typeof fetchConfig === 'function') {
      config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
    } else {
      config = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      };
    }

    config.body = formData;
    return config;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(customButtonSelector);
    if (!button) return;
    button.dataset.sppAjaxStartedAt = String(Date.now());
    clearFallbackError();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isCustomProductForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var button = getSubmitButton(form, event);
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' || form.getAttribute('data-spp-ajax-busy') === '1') {
      return;
    }

    form.setAttribute('data-spp-ajax-busy', '1');
    button.setAttribute('aria-disabled', 'true');
    clearFallbackError();

    var startedAt = Number(button.dataset.sppAjaxStartedAt || Date.now());
    var drawer = document.querySelector('cart-drawer');
    var formData = new FormData(form);

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      var sectionIds = drawer.getSectionsToRender().map(function (section) { return section.id; });
      formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', window.location.pathname);
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
    }

    var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';

    fetch(addUrl, makeFetchConfig(formData))
      .then(function (fetchResponse) {
        return fetchResponse.json().then(function (data) {
          return { ok: fetchResponse.ok, data: data };
        });
      })
      .then(function (result) {
        var response = result.data || {};

        if (!result.ok || response.status) {
          var message = response.description || response.message || 'We could not add this item to your cart. Please try again.';
          showFallbackError(message);
          publishCartError(formData, response);
          releaseForm(form, button);
          return;
        }

        renderDrawerWithoutOpening(drawer, response);
        signalCartSuccess(formData, response);
        scheduleDrawerOpen(drawer, form, button, startedAt);
      })
      .catch(function (error) {
        console.error('SPP add to cart error', error);
        showFallbackError('We could not add this item to your cart. Please try again.');
        publishCartError(formData, { message: error && error.message });
        releaseForm(form, button);
      });
  }, true);
})();
